import React, { useEffect, useState } from "react";
import { Line, Bar } from "react-chartjs-2";
import "./mainDashboard.css";
import { Progress } from "antd";
import { DatePicker } from "antd";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import { useTheme } from "../../utils/ThemeContext";
import FETCH from "../../utils/fetch";

export const DashboardGoalCharts = () => {
  const { theme } = useTheme();

  const [loading, setLoading] = useState(false);
  const [goalsData, setGoalsData] = useState([]);

  const getGoalsList = async () => {
    try {
      setLoading(true);
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");
      let response = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Goals&page=1&limit=20&clientId=${ID}`
            : `?module=Goals&page=1&limit=20`,
        body: {},
      });
      if (response && response.records) {
        setGoalsData(response.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getGoalsList();
  }, []);

  // function getMonthsDifference(date1, date2) {
  //   const year1 = date1.getFullYear();
  //   const year2 = date2.getFullYear();
  //   const month1 = date1.getMonth();
  //   const month2 = date2.getMonth();

  //   return (year2 - year1) * 12 + (month2 - month1);
  // }
    function getMonthsDifference(date1, date2) {
    let years = date2.getFullYear() - date1.getFullYear();
    let months = date2.getMonth() - date1.getMonth();
    let totalMonths = years * 12 + months;

    // Adjust if end day is less than start day (Excel style)
    if (date2.getDate() < date1.getDate()) {
      totalMonths--;
    }

    return totalMonths;
  }
  const calculateGoalNeed = (amountNeed, date) => {
    const GoalNeedToday = amountNeed ? amountNeed : 0;

    const GoalInflationRate = 10;
    let GoalDate = date ? new Date(date) : new Date();
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const todaysDate = new Date();
    const NumberofMonths = getMonthsDifference(todaysDate, GoalDate);
    if (!(GoalDate instanceof Date)) {
      GoalDate = new Date(GoalDate);
    }
    const daysBetween = (GoalDate - todaysDate) / (1000 * 60 * 60 * 24);

    const result =
      GoalNeedToday *
      Math.pow(
        1 + GoalInflationRate / 100 / 365,
        365 * ((GoalDate - todaysDate) / (1000 * 60 * 60 * 24) / 365) -
          NumberofMonths
      );
    console.log("result", result);
    return parseFloat(result).toFixed(2);
  };

  const { MonthPicker } = DatePicker;
  const extractedModules =
    goalsData && goalsData.map((item) => item["Description of Goal"]);
  const extractedHaveAmount =
    goalsData &&
    goalsData.map((item) => {
      return (
        (item.assignAssets && Array.isArray(item.assignAssets)
          ? item.assignAssets.reduce(
              (acc, curr) => acc + parseFloat(curr.amountUseForGoal || 0),
              0
            )
          : 0) +
        (item["Amount Received"] && Array.isArray(item["Amount Received"])
          ? item["Amount Received"].reduce(
              (acc, curr) => acc + parseFloat(curr || 0),
              0
            )
          : 0)
      )
        .toFixed(2)
        .toString();
    });

  const extractedNeedAmount =
    goalsData &&
    goalsData.map((item) => {
      return item["Dollar Amount Needed"]
        ? calculateGoalNeed(
            item["Dollar Amount Needed"],
            item["Goal Date"] ? item["Goal Date"] : new Date()
          )
        : 0;
    });

  const dataBar = {
    labels: extractedModules && extractedModules,
    datasets: [
      {
        label: "Have",
        data: extractedHaveAmount && extractedHaveAmount,
        fill: false,
        backgroundColor: "#B1E3FF",
        borderColor: "#B1E3FF",
      },
      {
        label: "Need",
        data: extractedNeedAmount && extractedNeedAmount,
        fill: false,
        backgroundColor: "#2A3DA3",
        borderColor: "#2A3DA3",
      },
    ],
  };
  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: "white",
        formatter: (value, context) => `${value}%`,
      },
    },
    legend: {
      labels: {
        fontColor: theme === "light" ? "#232323" : "white",
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          gridLines: {
            color: theme === "light" ? "#232323" : "white",
          },
          ticks: {
            fontColor: theme === "light" ? "#232323" : "white",
          },
          stacked: true,
        },
      ],
      yAxes: [
        {
          stacked: true,
          ticks: {
            fontColor: theme === "light" ? "#232323" : "white",
            beginAtZero: true, // This will ensure the y-axis starts from 0
            callback: function (value) {
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }).format(value);
            },
          },
        },
      ],
    },
    tooltips: {
      // enabled: false,
      callbacks: {
        label: (tooltipItem, dataBar) => {
          // Get the dataset label, global label or fall back to empty label
          let label =
            (dataBar.datasets[tooltipItem.datasetIndex].labels &&
              dataBar.datasets[tooltipItem.datasetIndex].labels[
                tooltipItem.index
              ]) ||
            dataBar.datasets[tooltipItem.datasetIndex].label ||
            dataBar.labels[tooltipItem.index] ||
            "";
          if (label) {
            label += ": ";
          }

          // Apply the value and suffix
          label +=
            dataBar.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] +
            (dataBar.datasets[tooltipItem.datasetIndex].labelSuffix || "");

          return label;
        },
      },
    },
    // legend: {
    //   onClick: () => {}, // Disable legend click
    // },
  };

  return (
    <React.Fragment>
      {" "}
      <div
        className="SavingMainCard2"
        style={{
          position: "relative",
          width: "100%",
          padding: "0px",
          borderRadius: "0px",
          backgroundColor: theme === "dark" ? "#232323" : "white",
        }}
      >
        <h1
          style={{
            color: theme === "light" ? "#232323" : "white",
          }}
          className="SavingCardheading"
        >
          Goals
        </h1>

        <div style={{ marginTop: "2rem", display: "flex" }}>
          <Bar data={dataBar} height={300} options={options} />
        </div>
        <NewLoader isLoading={loading} />
      </div>
    </React.Fragment>
  );
};
